module.exports = __webpack_public_path__ + "images/xl-shanxi.jpg?ac3242d38388144576d6b75f1566da51";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/xl-shanxi.jpg
// module id = 209
// module chunks = 1